/**
 * LP TOF — shared interactions (header, smooth scroll, bird selector, AJAX cart, etc.).
 */
;(function () {
  'use strict'

  const getRoutesRoot = () => {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root
    }
    return '/'
  }

  const readStickyBarConfig = () => {
    const el = document.getElementById('lp-sticky-bar-config')
    if (!el) return null
    try {
      return JSON.parse(el.textContent)
    } catch (e) {
      return null
    }
  }

  const LPCart = {
    productData: null,
    lastAddResponse: null,
    selectedSize: 'small',

    init() {
      const dataEl = document.getElementById('lp-product-data')
      if (dataEl) {
        try {
          this.productData = JSON.parse(dataEl.textContent)
        } catch (e) {
          console.error('LP: Failed to parse product data', e)
        }
      }
      this.bindEvents()
    },

    async addToCart(variantId) {
      if (!variantId) return

      const btn = document.querySelector(`[data-lp-atc="${variantId}"]`)
      if (btn) {
        btn.classList.add('lp-btn--loading')
        btn.disabled = true
      }

      try {
        const res = await fetch(getRoutesRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        })

        const data = await res.json().catch(() => ({}))

        if (!res.ok) {
          const msg =
            (typeof data.description === 'string' && data.description) ||
            data.message ||
            'Failed to add to cart'
          throw new Error(msg)
        }

        this.lastAddResponse = data
        await this.updateCartCount()
        // System cart feedback (not merchant-facing product copy). Localise via theme if needed.
        this.showToast('Added to cart!')
        this.openCartDrawer()
        return data
      } catch (error) {
        console.error('LP: Add to cart error', error)
        this.showToast(error.message || 'Could not add to cart. Please try again.', true)
      } finally {
        if (btn) {
          btn.classList.remove('lp-btn--loading')
          btn.disabled = false
        }
      }
    },

    async updateCartCount() {
      try {
        const res = await fetch(getRoutesRoot() + 'cart.js', {
          headers: { 'Content-Type': 'application/json' }
        })
        const cart = await res.json()
        const countEls = document.querySelectorAll('.cart-link__bubble-num')
        countEls.forEach((el) => {
          el.innerText = cart.item_count
        })
        const bubbles = document.querySelectorAll('.cart-link__bubble')
        bubbles.forEach((b) => {
          if (cart.item_count > 0) {
            b.classList.add('cart-link__bubble--visible')
          } else {
            b.classList.remove('cart-link__bubble--visible')
          }
        })
      } catch (e) {
        console.error('LP: Cart count update failed', e)
      }
    },

    showToast(message, isError) {
      let toast = document.querySelector('.lp-toast')
      if (!toast) {
        toast = document.createElement('div')
        toast.className = 'lp-toast'
        toast.setAttribute('role', 'status')
        document.body.appendChild(toast)
      }
      toast.textContent = message
      toast.classList.toggle('lp-toast--error', !!isError)
      toast.classList.add('is-visible')
      clearTimeout(toast._timeout)
      toast._timeout = window.setTimeout(() => toast.classList.remove('is-visible'), 3200)
    },

    bindEvents() {
      document.addEventListener('click', (e) => {
        const atcBtn = e.target.closest('[data-lp-atc]')
        if (!atcBtn) return
        const variantId = parseInt(atcBtn.getAttribute('data-lp-atc'), 10)
        if (!variantId) return
        e.preventDefault()
        this.addToCart(variantId)
      })
    },

    openCartDrawer() {
      const product = this.lastAddResponse

      const strategies = [
        () => {
          if (!product) return false
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: { product }
            })
          )
          return true
        },
        () => typeof window.SC_openNativeCart === 'function' && (window.SC_openNativeCart(), true),
        () => {
          if (typeof window.CartDrawer === 'undefined' || !window.CartDrawer.open) return false
          window.CartDrawer.open()
          return true
        },
        () => {
          if (typeof window.slide_cart === 'undefined' || !window.slide_cart.open) return false
          window.slide_cart.open()
          return true
        },
        () => {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
          )
          window.setTimeout(() => {
            const trigger = document.querySelector(
              '.js-drawer-open-cart, [data-cart-toggle], cart-drawer-button, .site-header__cart, .cart-link, a[href="/cart"]'
            )
            if (trigger) trigger.click()
          }, 150)
          return true
        },
        () => {
          if (!document.querySelector('#CartDrawer')) return false
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }))
          return true
        },
        () =>
          typeof window.theme !== 'undefined' &&
          window.theme.ajaxCart &&
          typeof window.theme.ajaxCart.update === 'function' &&
          (window.theme.ajaxCart.update(), true),
        () =>
          typeof window.Shopify !== 'undefined' &&
          window.Shopify.theme &&
          window.Shopify.theme.jsAjaxCart &&
          typeof window.Shopify.theme.jsAjaxCart.showDrawer === 'function' &&
          (window.Shopify.theme.jsAjaxCart.showDrawer(),
          window.Shopify.theme.jsAjaxCart.updateView &&
            window.Shopify.theme.jsAjaxCart.updateView(),
          true)
      ]

      for (let i = 0; i < strategies.length; i++) {
        try {
          const out = strategies[i]()
          if (out) return
        } catch (err) {
          continue
        }
      }

      window.location.href = getRoutesRoot() + 'cart'
    }
  }

  const readSelectorUi = () => {
    const el = document.getElementById('lp-selector-ui')
    if (!el) return { recommendationTemplate: '' }
    try {
      return JSON.parse(el.textContent)
    } catch (e) {
      return { recommendationTemplate: '' }
    }
  }

  const BirdSelector = {
    init() {
      const tiles = document.querySelectorAll('.lp-bird-tile')
      const recommendation = document.querySelector('[data-lp-recommendation]')
      const recText = recommendation ? recommendation.querySelector('.lp-recommendation__text') : null
      const productArea = document.querySelector('[data-lp-product-area]')
      const ui = readSelectorUi()

      if (!tiles.length) return

      tiles.forEach((tile) => {
        tile.addEventListener('click', () => {
          tiles.forEach((t) => {
            t.classList.remove('is-selected')
            t.setAttribute('aria-pressed', 'false')
          })
          tile.classList.add('is-selected')
          tile.setAttribute('aria-pressed', 'true')

          const speciesName = tile.getAttribute('data-species-name') || tile.getAttribute('data-species') || ''
          const size = tile.getAttribute('data-size') || tile.getAttribute('data-recommendation') || 'small'
          const sizeLabel = size === 'large' ? 'Large' : 'Small'

          let template = ui.recommendationTemplate || ''
          if (!template.trim()) {
            template = 'For your {species}, we recommend the {size} Seed Cube Kit.'
          }
          const sentence = template
            .replace(/\{species\}/g, speciesName)
            .replace(/\{size\}/g, sizeLabel)

          if (recText) {
            recText.textContent = sentence
          }

          if (recommendation) {
            recommendation.removeAttribute('hidden')
            recommendation.classList.add('is-visible')
          }

          if (productArea) {
            productArea.setAttribute('data-recommended-size', size)
          }

          LPCart.selectedSize = size
          BirdSelector.updateStickyBar(size)

          window.setTimeout(() => {
            if (!recommendation) return
            const headerEl = document.querySelector('.lp-header')
            const headerHeight = headerEl ? headerEl.offsetHeight : 64
            const top =
              recommendation.getBoundingClientRect().top + window.scrollY - headerHeight - 16
            window.scrollTo({ top, behavior: 'smooth' })
          }, 80)
        })
      })
    },

    updateStickyBar(size) {
      const bar = document.querySelector('.lp-sticky-bar')
      if (!bar || !LPCart.productData) return

      const product =
        size === 'large' ? LPCart.productData.large_kit : LPCart.productData.small_kit
      if (!product) return

      const cfg = readStickyBarConfig()
      const smallLabel = (cfg && cfg.small_label) || 'Small Seed Cube Kit'
      const largeLabel = (cfg && cfg.large_label) || 'Large Seed Cube Kit'

      const thumb = bar.querySelector('[data-lp-sticky-thumb]')
      const text = bar.querySelector('[data-lp-sticky-text]')
      const price = bar.querySelector('[data-lp-sticky-price]')
      const atcBtn = bar.querySelector('.lp-sticky-bar__atc')

      if (thumb) {
        if (product.image) {
          thumb.removeAttribute('hidden')
          thumb.src = product.image
          thumb.alt = product.title || ''
        } else {
          thumb.setAttribute('hidden', '')
          thumb.removeAttribute('src')
        }
      }
      if (text) {
        text.textContent = size === 'large' ? largeLabel : smallLabel
      }
      if (price) {
        price.textContent = product.price || ''
      }
      if (atcBtn) {
        if (product.id) {
          atcBtn.setAttribute('data-lp-atc', String(product.id))
          atcBtn.disabled = !product.available
        } else {
          atcBtn.removeAttribute('data-lp-atc')
          atcBtn.disabled = true
        }
      }
    }
  }

  const applyInitialStickyBarContent = () => {
    const bar = document.querySelector('.lp-sticky-bar')
    if (!bar) return

    const cfg = readStickyBarConfig()
    const thumb = bar.querySelector('[data-lp-sticky-thumb]')
    const text = bar.querySelector('[data-lp-sticky-text]')
    const price = bar.querySelector('[data-lp-sticky-price]')
    const atcBtn = bar.querySelector('.lp-sticky-bar__atc')

    if (cfg && cfg.default_product_id > 0) {
      if (thumb && cfg.default_product_image) {
        thumb.removeAttribute('hidden')
        thumb.src = cfg.default_product_image
        thumb.alt = cfg.default_product_title || ''
      } else if (thumb) {
        thumb.setAttribute('hidden', '')
        thumb.removeAttribute('src')
      }
      if (text) text.textContent = cfg.default_product_title || ''
      if (price) price.textContent = cfg.default_product_price || ''
      if (atcBtn) {
        atcBtn.setAttribute('data-lp-atc', String(cfg.default_product_id))
        atcBtn.disabled = false
      }
      return
    }

    if (LPCart.productData) {
      BirdSelector.updateStickyBar('small')
    }
  }

  const StickyBar = {
    init() {
      const bar = document.querySelector('.lp-sticky-bar')
      const hero = document.querySelector('.lp-hero')
      if (!bar || !hero) return

      const footer = document.querySelector('.lp-footer')

      const showDesktop = bar.dataset.showDesktop === 'true'

      const hideBar = () => {
        bar.classList.remove('is-visible')
        bar.setAttribute('aria-hidden', 'true')
      }

      const heroObserver = new IntersectionObserver(
        ([entry]) => {
          if (!showDesktop && window.innerWidth >= 768) {
            hideBar()
            return
          }
          if (!entry.isIntersecting) {
            bar.classList.add('is-visible')
            bar.setAttribute('aria-hidden', 'false')
          } else {
            hideBar()
          }
        },
        { threshold: 0 }
      )
      heroObserver.observe(hero)

      if (footer) {
        const footerObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              hideBar()
            }
          },
          { threshold: 0.1 }
        )
        footerObserver.observe(footer)
      }

      window.addEventListener('resize', () => {
        if (!showDesktop && window.innerWidth >= 768) {
          hideBar()
        }
      })
    }
  }

  const StickyHeader = {
    init() {
      const header = document.querySelector('.lp-header')
      if (!header) return

      const observer = new IntersectionObserver(
        ([entry]) => {
          header.classList.toggle('header--scrolled', !entry.isIntersecting)
        },
        { threshold: 0, rootMargin: '-64px 0px 0px 0px' }
      )

      const hero = document.querySelector('.lp-hero')
      if (hero) observer.observe(hero)
    }
  }

  const LazyVideo = {
    init() {
      const videos = document.querySelectorAll('.lp-lazy-video')
      if (!videos.length) return

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            const video = entry.target
            const src = video.dataset.src
            if (src && !video.src) {
              video.src = src
              video.load()
              const playPromise = video.play()
              if (playPromise !== undefined) {
                playPromise.catch(() => {})
              }
            }
            observer.unobserve(video)
          })
        },
        { rootMargin: '200px' }
      )

      videos.forEach((v) => observer.observe(v))
    }
  }

  const ReviewReadMore = {
    init() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.lp-review-text__toggle')
        if (!btn) return
        const id = btn.getAttribute('aria-controls')
        const textEl = id ? document.getElementById(id) : null
        if (!textEl) return
        const expanded = textEl.classList.toggle('lp-review-text--expanded')
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false')
        // Fallback strings are UI chrome for the expand control, not storefront product copy.
        const less = btn.dataset.labelLess
        const more = btn.dataset.labelMore
        btn.textContent = expanded ? less || 'Read less' : more || 'Read more'
      })
    }
  }

  const FaqAccordion = {
    closeItem(item) {
      const btn = item.querySelector('.lp-faq-question')
      const answer = item.querySelector('.lp-faq-answer')
      if (!btn || !answer) return
      item.classList.remove('is-open')
      btn.setAttribute('aria-expanded', 'false')
      answer.setAttribute('aria-hidden', 'true')
      answer.style.maxHeight = '0px'
      const plus = btn.querySelector('.lp-faq-icon--plus')
      const minus = btn.querySelector('.lp-faq-icon--minus')
      if (plus) plus.removeAttribute('hidden')
      if (minus) minus.setAttribute('hidden', '')
    },

    init() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.lp-faq-question')
        if (!btn) return

        const item = btn.closest('.lp-faq-item')
        const answer = item ? item.querySelector('.lp-faq-answer') : null
        if (!item || !answer) return

        const isOpen = item.classList.contains('is-open')

        document.querySelectorAll('.lp-faq-item.is-open').forEach((openItem) => {
          if (openItem === item) return
          FaqAccordion.closeItem(openItem)
        })

        if (isOpen) {
          FaqAccordion.closeItem(item)
          return
        }

        item.classList.add('is-open')
        btn.setAttribute('aria-expanded', 'true')
        answer.setAttribute('aria-hidden', 'false')
        const inner = answer.querySelector('.lp-faq-answer-inner')
        const h = inner ? inner.scrollHeight : answer.scrollHeight
        answer.style.maxHeight = `${h}px`

        const plus = btn.querySelector('.lp-faq-icon--plus')
        const minus = btn.querySelector('.lp-faq-icon--minus')
        if (plus) plus.setAttribute('hidden', '')
        if (minus) minus.removeAttribute('hidden')
      })
    }
  }

  const RevealOnScroll = {
    init() {
      const els = document.querySelectorAll('.lp-reveal')
      if (!els.length) return
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible')
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      )
      els.forEach((el) => observer.observe(el))
    }
  }

  const SmoothScroll = {
    init() {
      document.addEventListener('click', (e) => {
        const el = e.target.closest('a[href^="#"], [data-scroll-to]')
        if (!el) return

        const href = el.getAttribute('href')
        const targetId =
          (href && href.startsWith('#') ? href.replace('#', '') : '') || el.dataset.scrollTo
        if (!targetId) return

        const target = document.getElementById(targetId)
        if (!target) return

        e.preventDefault()
        const headerEl = document.querySelector('.lp-header')
        const headerHeight = headerEl ? headerEl.offsetHeight : 64
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16
        window.scrollTo({ top, behavior: 'smooth' })

        const preselectSize = el.dataset.preselectSize
        if (!preselectSize) return

        window.setTimeout(() => {
          const firstTileForSize = document.querySelector(
            `.lp-bird-tile[data-size="${preselectSize}"]`
          )
          if (firstTileForSize && !firstTileForSize.classList.contains('is-selected')) {
            firstTileForSize.click()
          }
        }, 600)
      })
    }
  }

  const init = () => {
    RevealOnScroll.init()
    StickyHeader.init()
    SmoothScroll.init()
    LazyVideo.init()
    ReviewReadMore.init()
    LPCart.init()
    BirdSelector.init()
    applyInitialStickyBarContent()
    StickyBar.init()
    FaqAccordion.init()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
